// Content sourced verbatim from the client's supplied Melbourne guide copy.
import { galleryFrom, leadFrom, countFrom } from "./fromModels";

const slug = "bambra-studio";

const bambra = {
  slug,
  name: "Bambra Studio",
  short: "Bambra",
  badge: "Caulfield South Studio",
  suburb: "Caulfield South",
  established: "977 Glen Huntly Road, Caulfield South",
  tagline:
    "A smaller southeastern studio on Glen Huntly Road, particularly associated with mature companions.",
  lead: leadFrom(slug),
  theme: {
    bg: "bg-[#fff9ec]",
    chip: "bg-[#fdedc8] text-[#7a4c05]",
    rule: "border-[#efc873]",
    accent: "text-[#8a5406]",
  },
  gallery: galleryFrom(slug),
  highlights: [
    { icon: "Users", label: `${countFrom(slug)} Ladies` },
    { icon: "MapPin", label: "Caulfield South" },
    { icon: "Clock", label: "Confirm current hours" },
  ],
  contact: {
    address: "977 Glen Huntly Road, Caulfield South",
  },
  nav: [
    { id: "introduction", label: "Introduction" },
    { id: "models", label: "Models" },
  ],
  sections: [
    {
      id: "introduction",
      eyebrow: "Bambra Studio, Caulfield South",
      title: "Bambra Studio, Caulfield South",
      blocks: [
        { t: "lead", text: "Address: 977 Glen Huntly Road, Caulfield South" },
        { t: "p", text: "Bambra Studio isn't in one of Melbourne's obvious nightlife districts." },
        {
          t: "p",
          text: "You'll find it along Glen Huntly Road in Caulfield South, surrounded by the sort of shops and residential streets you'd expect in an established southeastern suburb.",
        },
        {
          t: "p",
          text: "That setting gives it a different character from the larger establishments around South Melbourne.",
        },
        {
          t: "p",
          text: "The premises have a history that predates the Bambra name. Older visitors may remember the business as Georgie's Place, a name that still appears in discussions about Melbourne's adult industry.",
        },
        {
          t: "p",
          text: "It's a useful detail because someone researching Bambra might come across old references to Georgie's and not realise they're connected.",
        },
        {
          t: "p",
          text: "Today, Bambra is particularly associated with mature companions, including women in their thirties and older. That's a point of difference in a market where many establishments concentrate their advertising on younger workers.",
        },
        {
          t: "p",
          text: "Of course, people's preferences vary. Some visitors are interested in a wider age range, while others specifically prefer mature companions.",
        },
        {
          t: "p",
          text: "The smaller studio setting may also appeal to someone who isn't especially interested in large reception lounges or elaborate entertainment facilities.",
        },
        { t: "p", text: "Then there's the location." },
        {
          t: "p",
          text: "For anyone travelling from Caulfield, Bentleigh, Brighton or nearby suburbs, Bambra is considerably more convenient than heading into central Melbourne. It also sits away from the main cluster of adult businesses around South Melbourne.",
        },
        {
          t: "p",
          text: "The older Georgie's Place name has generated independent customer discussion over the years, although experiences and expectations differ. Historical feedback is useful background, but it doesn't necessarily describe the business as it operates today.",
        },
        {
          t: "p",
          text: "If you're considering Bambra, it's worth asking who is available, what the current booking arrangements are and how pricing works.",
        },
        {
          t: "p",
          text: "You don't need to know every detail before visiting. But you should understand the basics, particularly if you're travelling specifically to meet someone.",
        },
        {
          t: "note",
          text: "You can find the business's contact details at Bambra Studio.",
        },
      ],
    },
  ],
};

export default bambra;
